var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row my-4"},[_c('div',{staticClass:"col-12 pb-5"},[_c('router-link',{attrs:{"to":{
              name: 'list',
              query: { store: this.$route.query.store , category:_vm.data[0].category_id,
              name:_vm.data[0].category_name,
              isFromStore:true
              },
              params: {
                menu_url_key: ("store-" + (_vm.$route.query.store))
              }
            }}},[_c('img',{staticClass:"img-fluid",attrs:{"src":_vm.data[0].img_path,"alt":""}}),(_vm.data[0].category_name.length > 2)?_c('a',{staticClass:"grid-2-btn",attrs:{"href":"#"}},[_vm._v("\n              "+_vm._s(_vm.data[0].category_name)+"\n            ")]):_vm._e()])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }